// Partner Logo grid script

$(function() {
    var $container = $('.neo4j-user-logos'),
        $select = $('.js-filter-option'),
        state = {
            region: '', 
            type: '',
            tech: '',
            search: '',
        };

    // Set state
    set_state_from_url()

    // Init Isotope
    $container.imagesLoaded( function() {
        $container.isotope({
            layoutMode: 'fitRows',
            itemSelector: '.customer-box',
            filter: getFilter() // gets filter based on state
        });
    });

    // Set some inline styling
    $("select").css("outline", "none");
    $("select").css("box-shadow", "none");

    /******* Handlers ********/

    $('#see-more-button').on("click", unhide_overflow_companies);
    // Stop search form submit
    $('#searchform').on('submit', function(e) { e.preventDefault() } );

    // Select handler
    $select.change(filterOptions).keyup(filterOptions);

    /******** Functions **********/

    function set_state_from_url() {
        // Only update if there are any filter params
        let addr = new URL(window.location);
        if (addr.searchParams.has('region') || 
            addr.searchParams.has('type') || 
            addr.searchParams.has('search')) {

            // Go through all params and update matching state
            for(var pair of addr.searchParams.entries()) {
                $.each(state, function(index, value) {
                    if ( index == pair[0] ) {
                        state[index] = pair[1]
                        // Add period before class based filters
                        if (pair[0] != 'search') {
                            state[index] = '.' + state[index]
                        }
                        // Filter out trailing slash if pulled from URL
                        if (state[index].slice(-1) == '/') {
                            state[index] = state[index].slice(0,-1);
                        }
                    }
                })
            }

            //Update select values
            setSelectState()
        }
    }   

    function filterOptions() {
        var $this = $(this),
            value = ($this.val() == '*' ? '' : $this.val()); // Replace any star wild characters with empty string
            filter = $this.data('filter');

        /* State logic */
        // Update state for changed filter
        state[filter] = value;
        // Update other states based on changed filter
        // If search clear out others
        if (filter == 'search') {
            state.region = '';
            state.type = '';
            state.tech = '';  
        // If not search clear out search
        } else {
            state.search = '';
        }
        // Make sure to reset tech type to all if parent "Technology Partner" isn't selected
        if(filter == 'type' && value != ".Technology_Partner") state.tech = '';

        // Update layout after filter changes
        updateUI();

        // Update state
        updateURLParams()
    }

    function updateURLParams() {
        // Get base url
        const url = new URL(window.location.href.split('?')[0]);
        // Loop through filter states and add params
        $.each(state, function(index, value) {
            // Strip class period out
            value = value.replace('.','')
            // Don't add param is set to 'All'
            if ( value != '' ) url.searchParams.set(index, value)
            
        })
        // Push to browser history
        window.history.replaceState({}, '', url );
    }

    // Sets the select field to current filter state
    function setSelectState() {
        var $selectRegion =  $('#filter-region'),
            $selectType = $('#filter-type'),
            $selectTech = $('#filter-tech'),
            $searchField = $('#partner-search');

        // region
        if (state.region) {
            $selectRegion.val(state.region);
        } else {
            $selectRegion.val('*');
        }

        // Partner type
        if (state.type) {
            $selectType.val(state.type);
        } else {
            $selectType.val('*');
        }

        // Show Tech type select field
        if (state.type == '.Technology_Partner' ? showTechTypeSelect() : hideTechTypeSelect());

        // tech type
        if (state.tech) {
            $selectTech.val(state.tech);
        } else {
            $selectTech.val('*');
        }

        // Search
        if (state.search) {
            $searchField.val(state.search);
        } else {
            $searchField.val('');
        }
    }

    // Returns filter for isotope
    // Either a search query on name or category filter
    function getFilter() {
        var filter = '';

        if (state.search) {
            filter = function() {
                var name = $(this).find('.plaintext').text().trim(),
                    query = RegExp(state.search, 'gi');
          
                return name.match( query );
            };
        } else {
            filter = getFilterStr();
        }

        return filter;
    }

    // Returns formated Isotope filter string based on different filter logic
    // Adds the global filter to any "global" regions based on list
    function getFilterStr() {
        var filterStr = '',
            regionList = ['.Americas','.Asia_Pacific','.Europe'];

        if( $.inArray(state.region, regionList) != -1){
            filterStr = state.region + state.type + state.tech + ", .Global" + state.type + state.tech;
        } else {
            filterStr = state.region + state.type + state.tech;
        }

        return filterStr;
    }

    // Update UI from state variables
    function updateUI() {
        $('#no-results').hide();
        // Update select UI
        setSelectState();
        // Filter Isotope
        $container.isotope({filter: getFilter()});
        // UI updates after isotope layout changes
        $container.isotope( 'on', 'layoutComplete', function (isoInstance, laidOutItems) {
            if(laidOutItems.length == 0){
                $('#no-results').show();
                $("#logo-hide-window").css("height", "inherit");
            } else {
                // Show all results
                unhide_overflow_companies();
            }
        });
    }

    function unhide_overflow_companies(){
        $("#logo-hide-window").css("height", "inherit");
        $('#see-more-button').hide();
    }

    function showTechTypeSelect() {
        $(".filter-row > div").removeClass("medium-4");
        $(".filter-row > div").addClass("medium-3");
        $(".filter-row .tech-type").css("display","block");
    }

    function hideTechTypeSelect() {
        $(".filter-row > div").removeClass("medium-3");
        $(".filter-row > div").addClass("medium-4");
        $(".filter-row .tech-type").css("display","none");
    }
});
